
    import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
    import AbpBase from '../lib/abpbase'

    @Component
    export default class LanguageList extends AbpBase {
        get languages() {
            return abp.localization.languages.filter(val => {
                return !val.isDisabled && val.name !== this.currentLanguage.name;
            });
        }

        async changeLanguage(languageName: string) {
            await this.$store.dispatch('profile/changeLanguage', {languageName: languageName})
            abp.utils.setCookieValue(
                "Abp.Localization.CultureName",
                languageName,
                new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
                abp.appPath
            );
            location.reload();
        }

        get currentLanguage() {
            return abp.localization.currentLanguage;
        }
    }
